export default "__VITE_ASSET__B9CQ6aWe__"